export default __webpack_public_path__ + "static/taylor-bitmoji-1e67fad92718adc91bb9c4ee1c321dc2.png";